var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0744 11L7.53687 6.4625L8.83303 5.16633L14.6667 11L8.83303 16.8337L7.53687 15.5375L12.0744 11Z","fill":"#E94057"}));
}

ArrowRight.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
